// https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
// https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
/* eslint-disable no-restricted-imports */

import { canUseWindow } from '@/utils/browser/window'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useLayoutEffect, useEffect } from 'react'

const useIsomorphicLayoutEffect = canUseWindow ? useLayoutEffect : useEffect

export default useIsomorphicLayoutEffect
